<!-- 管理员信息认证审核-->
<template>
    <div class="" >        
        <div class="detail-wrap">  
            <PageBack :title="title" />  
            <el-tabs  v-model="activeName" @tab-click="changeTabs"  type="card">
                <el-tab-pane label="待审核认证信息" name="a" > 
                <el-table border :data="tableData" style="width: 100%;">
                <el-table-column  prop="username"  label="全称" />
                <el-table-column  prop="shortname"  label="简称" />
                <el-table-column  prop="phone"   label="手机号" />
                <el-table-column  prop="role"  label="角色" />
                <el-table-column  prop="level"  label="等级"  />
                <el-table-column  prop="status" label="状态"  />
                <el-table-column  prop="roleUrl" label="身份证正面">
                    <template slot-scope="scope">
                        <span v-if="scope.row.roleUrl===''">暂无</span>
                        <el-image :src="scope.row.roleUrl" :preview-src-list="scope.row.srcList" v-else ></el-image>
                    </template>
                </el-table-column>
                <el-table-column  prop="levelUrl" label="身份证反面">
                    <template slot-scope="scope">
                        <span v-if="scope.row.levelUrl===''">暂无</span>
                        <el-image :src="scope.row.levelUrl" :preview-src-list="scope.row.srcList" v-else></el-image>
                    </template>
                </el-table-column>
                <el-table-column  prop="imageLisence" label="凭证图片">
                    <template slot-scope="scope" >
                        <span v-if="scope.row.imageLisence===''">暂无</span>
                        <el-image :src="scope.row.imageLisence" :preview-src-list="scope.row.srcList" v-else></el-image>
                    </template>
                </el-table-column>
                <el-table-column  fixed="right" label="操作"  width="120">
                    <template slot-scope="scope"  v-if="scope.row.status === '待审核'">
                        <el-button @click="handleAudit(scope.row,1)" type="text" size="medium">同意</el-button>
                        <el-button @click="handleAudit(scope.row,2)" type="text" size="medium">拒绝</el-button>
                    </template>                   
                </el-table-column>
                </el-table>
                </el-tab-pane>
                <el-tab-pane label="会员列表" name="b" >                
                <el-form :model="searchForm" ref="searchForm" :inline="true"> 
                    <el-row>               
                    <el-form-item label="姓名" prop="username">
                        <el-input v-model="searchForm.username" placeholder="请输入会员姓名"></el-input>
                    </el-form-item>    
                    <el-form-item label="手机号" prop="phone" >
                        <el-input v-model="searchForm.phone" placeholder="请输入会员手机号"></el-input>
                    </el-form-item>                     
                    <el-form-item>
                        <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button>
                        <el-button @click="resetForm('searchForm')">重置</el-button>  
                        <el-button type="success" @click="handleExport">导出</el-button>
                        <el-button type="danger" @click="sendMemberInfo">同步</el-button>                     
                    </el-form-item>    
                </el-row>
                <el-row>   
                    <el-form-item label="角色" prop="roleId" >
                        <el-select v-model="searchForm.roleId">
                            <el-option
                                v-for="item in roleOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                >
                            </el-option>
                        </el-select>
                    </el-form-item>                  
                    <el-form-item label="省" prop="province">
                        <el-select v-model="searchForm.province"  @change="handleChangeArea" placeholder="请选择省">
                            <el-option
                                v-for="item in areaList"
                                :key="item.code"
                                :label="item.label"
                                :value="item.label"
                                >
                            </el-option>
                        </el-select>
                    </el-form-item> 
                    <el-form-item label="市" prop="city">
                            <el-select v-model="searchForm.city"  @change="handleChangecity" placeholder="请选择市">
                                <el-option
                                    v-for="item in cityList"
                                    :key="item.code"
                                    :label="item.label"
                                    :value="item.label"
                                    >
                                </el-option>
                            </el-select>
                        </el-form-item>  
                        <el-form-item>
                            <!-- 一键同步会员信息 -->                                              
                        </el-form-item>      
                    </el-row> 
                </el-form>
                <el-table border 
                    :data="tableData2"
                    style="width: 100%;"
                    v-loading.fullscreen="loading"
                    element-loading-text="正在同步会员信息，请稍后..." 
                    >
                    <el-table-column  prop="userId"  label="会员账号" width="100"/>
                    <el-table-column  prop="username"  label="全称" />
                    <el-table-column  prop="shortname"  label="姓名" sortable/>
                    <el-table-column  prop="phone"   label="手机号" width="120"/>
                    <el-table-column  prop="role"  label="角色" sortable/>
                    <el-table-column  prop="area"  label="地区" sortable/>
                    <el-table-column  prop="level" label="等级" width="150" sortable>
                    <template slot-scope="scope">
                        <div v-if="scope.row.role === '选手'">
                            <el-rate v-model="scope.row.level" 
                                disabled  show-score text-color="#ff9900"></el-rate>
                        </div>
                        <div v-else>
                            {{ scope.row.level }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column  prop="score" label="积分"  width="80" sortable/>
                <el-table-column  prop="roleUrl" label="身份证正面">
                    <template slot-scope="scope">
                        <span v-if="scope.row.roleUrl===''">暂无</span>
                        <el-image :src="scope.row.roleUrl" :preview-src-list="scope.row.srcList" v-else></el-image>
                    </template>
                </el-table-column>
                <el-table-column  prop="levelUrl" label="身份证反面">
                    <template slot-scope="scope">
                        <span v-if="scope.row.levelUrl===''">暂无</span>
                        <el-image :src="scope.row.levelUrl" :preview-src-list="scope.row.srcList" v-else></el-image>
                    </template>
                </el-table-column>
                <el-table-column  prop="imageLisence" label="凭证图片">
                    <template slot-scope="scope" >
                        <span v-if="scope.row.imageLisence===''">暂无</span>
                        <el-image :src="scope.row.imageLisence" :preview-src-list="scope.row.srcList" v-else></el-image>
                    </template>
                </el-table-column>
                <el-table-column  fixed="right" label="操作"  width="180">
                    <template slot-scope="scope" v-if="roles">                        
                        <el-button  @click="handleScore(scope.row,1)" type="text" size="medium" >加积分</el-button>
                        <el-button  @click="handleScore(scope.row,2)" type="text" size="medium" >减积分</el-button>
                        <el-button  @click="handleSetting(scope.row)" type="text" size="medium" >设置</el-button>
                    </template>                   
                </el-table-column>
                </el-table>
                <pagination
                    style="text-align:right"
                    v-show="total > 10"
                    :total="total"
                    :page.sync="queryParams.page"
                    :limit.sync="queryParams.pagesize"
                    @pagination="getUserList"
                />
                </el-tab-pane>
            </el-tabs>
        </div>
<el-dialog
    title="用户认证审核"
    :visible.sync="dialogVisible"        
    :before-close="handleClose">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px">
        <el-form-item label="等级" prop="level">
            <el-select v-model="ruleForm.level" style="width:100%">
                <el-option 
                    v-for="item in levelOption"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="理由" prop="reason">
            <el-input v-model="ruleForm.reason" placeholde="请输入理由"></el-input>
        </el-form-item>
    </el-form>        
    <span slot="footer" class="dialog-footer">      
        <el-button  @click="handleClose">取消</el-button> 
        <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
    </span>
</el-dialog>
<el-dialog
    :title="refuseMsg"
    :visible.sync="dialogVisible2"        
    :before-close="handleClose2">
    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="100px">
        <el-form-item label="拒绝理由" prop="reason">
            <el-input v-model="ruleForm2.reason" placeholder="请输入拒绝理由"></el-input>
        </el-form-item>
    </el-form>        
    <span slot="footer" class="dialog-footer">      
        <el-button  @click="handleClose2">取消</el-button> 
        <el-button type="primary" @click="submitAudit('ruleForm2')">确认</el-button>
    </span>
</el-dialog>
<el-dialog
    title="积分设置"
    :visible.sync="showScore"        
    :before-close="handleClose3">
    <el-form :model="ruleForm3" :rules="rules3" ref="ruleForm3" label-width="100px">
        <el-form-item label="分数" prop="score">
            <el-input v-model="ruleForm3.score" placeholder="请输入分数"></el-input>
        </el-form-item>
    </el-form>        
    <span slot="footer" class="dialog-footer">      
        <el-button  @click="handleClose3">取消</el-button> 
        <el-button type="primary" @click="submitScore('ruleForm3')">确认</el-button>
    </span>
</el-dialog>
<el-dialog
    title="设置角色"
    :visible.sync="showRole"        
    :before-close="handleClose4">
    <el-form :model="ruleForm4" :rules="rules4" ref="ruleForm4" label-width="100px">
        <el-form-item label="角色" prop="role">
            <el-select v-model="ruleForm4.role" style="width:100%" @change="handleSelectRole">
                <el-option 
                    v-for="item in roleOption"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="等级" prop="level">
            <el-select v-model="ruleForm4.level" style="width:100%">
                <el-option 
                    v-for="item in levelOption"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>
    </el-form>        
    <span slot="footer" class="dialog-footer">      
        <el-button  @click="handleClose4">取消</el-button> 
        <el-button type="primary" @click="submitRole('ruleForm4')">确认</el-button>
    </span>
    </el-dialog>
</div>
</template>
    
<script>
import pagination  from '@/components/Pagination'
import Breadcrumb from '@/components/Breadcrumb'
import PageBack from '@/components/PageHeader'
import areaList from '@/assets/js/city'
export default {
    components:{
        pagination,
        Breadcrumb,
        PageBack
    },
    data() {
        return {
            activeName: 'a',
            searchForm:{
                userId: '',
                username: '',
                phone: '',
                province: '',
                city: '',
                roleId: ''
            },
            queryParams: {
                page: 1,
                pagesize: 10
            },
            areaList: areaList.provinces,
            cityList: [],
            tableData: [],  
            tableData2: [],
            amount: 0,  
            total: 0,
            levelOption: [],
            roleOption: [],
            ruleForm:{
                level: '',
                reason:''
            },
            ruleForm2: {
                reason: ''
            },
            ruleForm3:{
                score: null
            }, 
            ruleForm4:{
                role: '',
                level: '',
            }, 
            dialogVisible: false,
            dialogVisible2: false,
            showRole: false,
            refuseMsg: '',
            rules: {
                level: [
                    { required: true, message: '请选择等级', trigger: 'change' },
                ],  
            },
            rules2: {
                reason: [
                    { required: true, message: '请输入拒绝理由', trigger: 'blur' },
                ],  
            },
            rules3: {
                score: [
                    { required: true, message: '请输入分数', trigger: 'blur' },
                ],  
            },
            rules4: {
                score: [
                    { required: true, message: '请选择角色', trigger: 'change' },
                ],  
            },
            userId: '',
            flag: '',
            clientNo: '',
            showScore: false,
            scoreFlag: null,
            loading: false,
            exportData: []
        }   
    },
    created() {
        this.initData()
        this.getUserRole()            
    },
    mounted() {
        
    },
    computed:{
        title(){
            return this.$route.meta.title
        },
        roles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'){
                return true
            }else{
                return false
            }            
        }    
    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.AdminCode,
                i_client_no: 0,
                c_status: 7,               
            }
            this.$api.requestAPI(params).then(res =>{
            if (res.IsSuccess) {
                let result = res.Data.DataTable   
                if(result.length > 0 ){                                
                this.tableData = result.map(item=>{
                    // let roleUrl =  item['凭证正面'] ? this.$global.uploadUrl + item['凭证正面'] : '暂无'
                    // let levelUrl =  item['凭证背面'] ? this.$global.uploadUrl + item['凭证背面'] : '暂无'
                    // let imageLisence =  item['备注'] ? this.$global.uploadUrl + item['备注'] : '暂无'
                    let roleUrl = ''
                    let levelUrl = ''
                    let imageLisence = ''
                    if(item['凭证正面']!==''){
                        if((item['凭证正面']).includes('/img')){
                            roleUrl = item['凭证正面']
                        }else{
                            roleUrl = this.$global.uploadUrl + item['凭证正面']
                        }
                    }else{
                        roleUrl = ''
                    }
                    if(item['凭证背面']!==''){
                        if((item['凭证背面']).includes('/img')){
                            levelUrl = item['凭证背面']
                        }else{
                            levelUrl = this.$global.uploadUrl + item['凭证背面']
                        }
                    }else{
                        levelUrl = ''
                    }
                    if(item['备注']!==''){
                        if((item['备注']).includes('/img')){
                            imageLisence = item['备注']
                        }else{
                            imageLisence = this.$global.uploadUrl + item['备注']
                        }
                    }else{
                        imageLisence = ''
                    }
                        return{
                            userId: item['会员账号'],
                            username: item['全称'],
                            shortname: item['姓名'],
                            phone: item['手机号'],
                            role: item['角色'],
                            level: item['等级'],
                            company: item['公司'],
                            // imageUrl1: item['凭证正面'],
                            // imageUrl2: item['凭证背面'],   
                            status: item['状态'], 
                            roleUrl: roleUrl,
                            levelUrl:levelUrl,
                            imageLisence: imageLisence,
                            srcList:[roleUrl,levelUrl,imageLisence]
                        }
                    })
                    // console.log('1---',this.tableData)
                }else{
                    this.tableData = []
                }  
            }
        })
    },
    // 获取已认证会员信息
    getUserList(){
        let {userId, username, phone, province, city,roleId}  = this.searchForm
        let params ={
            opcode: this.$code.MemberRank,
            i_client_no: userId,
            v_name: username,
            v_phone: phone,
            v_provice: province,
            v_city: city,
            c_type: roleId,
            pagesize: this.queryParams.pagesize,
            page:  this.queryParams.page,
        }
        this.$api.requestAPI(params).then(res =>{
            if(res.IsSuccess){
                let result = res.Data.DataTable
                this.total = res.Data.SumCount
                if(result.length > 0 ){   
                this.tableData2 = result.map(item=>{
                    let roleUrl = ''
                    let levelUrl = ''
                    let imageLisence = ''
                    // let roleUrl = item['凭证正面']!=='' && (item['凭证正面']).includes('/img') ? item['凭证正面']: 
                    // this.$global.uploadUrl + item['凭证正面']
                    // let levelUrl =  item['凭证背面']!=='' && (item['凭证背面']).includes('/img')? item['凭证背面']:
                    // this.$global.uploadUrl + item['凭证背面']
                    if(item['凭证正面']!==''){
                        if((item['凭证正面']).includes('/img')){
                            roleUrl = item['凭证正面']
                        }else{
                            roleUrl = this.$global.uploadUrl + item['凭证正面']
                        }
                    }else{
                        roleUrl = ''
                    }
                    if(item['凭证背面']!==''){
                        if((item['凭证背面']).includes('/img')){
                            levelUrl = item['凭证背面']
                        }else{
                            levelUrl = this.$global.uploadUrl + item['凭证背面']
                        }
                    }else{
                        levelUrl = ''
                    }
                    if(item['备注']!==''){
                        if((item['备注']).includes('/img')){
                            imageLisence = item['备注']
                        }else{
                            imageLisence = this.$global.uploadUrl + item['备注']
                        }
                    }else{
                        imageLisence = ''
                    }
                    return{
                        userId: item['选手账号'],
                        username: item['全称'],
                        shortname: item['姓名'],
                        phone: item['手机号'],
                        role: item['角色'],
                        area: item['省'] + item['市'],
                        level: item['角色'] === '选手'? Number(item['等级']):item['等级'],
                        score: item['积分'],
                        company: item['公司'],
                        // imageUrl1: item['凭证正面'],
                        // imageUrl2: item['凭证背面'],   
                        roleUrl: roleUrl,
                        levelUrl: levelUrl,
                        imageLisence: imageLisence,
                        srcList:[roleUrl,levelUrl,imageLisence]
                    }
                }) 
                // console.log('2---',this.tableData2)
                }else{
                    this.tableData2 = []
                }
            }else{               
                this.$message.error(res.Message)
            }
        })
    },
    //选择角色对应等级 
    selectRole(value){
        let roleNo;
        if(value === '选手'){
            roleNo = 120
        }else  if(value === '教练'){
            roleNo = 102
        }else if(value === '裁判'){
            roleNo = 103  
        }else if(value === '掼蛋协会'){
            roleNo = 104
        }else if(value === '掼蛋俱乐部'){
            roleNo = 105
        }
        setTimeout(()=>{
            this.getRoleAsLevel(roleNo)
        },10)
    },
    // 获取角色对应等级
    getRoleAsLevel(no){
        let params = {
            opcode: this.$code.SystemCode,
            v_parent_name: '',
            i_no: no,
        }
        this.$api._requestAPI(params).then(res =>{
            if (res.IsSuccess) {
                let result = res.Data.DataTable
                this.levelOption = result.map(item=>{
                    return{
                        value: item['词条索引'],
                        label: item['中文描述']
                    }
                })
                // console.log(this.levelOption)
            }
        })
    },
    // 获取用户角色
    getUserRole(){
        let params = {
            opcode: this.$code.SystemCode,
            v_parent_name: '',
            i_no: 10,
        }
        this.$api._requestAPI(params).then(res =>{
            if (res.IsSuccess) {
                let result = res.Data.DataTable
                let arr  = result.map(item=>{
                    return{
                        value: item['词条索引'],
                        label: item['中文描述']
                    }
                })
                // i.label !=='选手' 
                this.roleOption = arr.filter(i=>i.label !== '管理员')
            }
        })
    },
    // 会员等级确认
    memberConfirm(){
        let params ={
            opcode: this.$code.MemberAudit,
            i_client_no: this.userId,
            i_starrating_new: this.ruleForm.level,
        }
        this.$api.requestAPI(params).then(res =>{
            if(res.IsSuccess){
                this.submitAudit('ruleForm')  
            }else{
                this.$message.error(res.Message)
            }
        })
    },
    handleAudit(row,i){  
        this.flag = i
        this.userId = row.userId
        if(i === 1){
            this.dialogVisible = true    
            this.selectRole(row.role)          
        }else{
            this.refuseMsg = `确认拒绝，会员账号为" ` + row.userId + ' "的信息认证申请吗？'
            this.dialogVisible2 = true
            
            // this.$confirm(`确认 ${this.flag} 会员账号为" ` + row.userId + ' "的信息认证申请吗？', "警告", {
            //     confirmButtonText: "确定",
            //     cancelButtonText: "取消",
            //     type: "warning"
            // }).then(()=> {
            //     this.submitAudit();
            // })            
        }           
    },
    submitForm(){
        this.memberConfirm()
    },
    submitAudit(formName){     
        let reason =  this.flag === 1 ? this.ruleForm.reason : this.ruleForm2.reason   
        this.$refs[formName].validate((valid) => {
            if (valid) {
                let params = {
                    opcode:this.$code.AdminAudit,
                    i_client_no: this.userId,
                    c_status: this.flag,
                    v_reason: reason
                };
                this.$api.requestAPI(params).then( res =>{
                    if(res.IsSuccess){                    
                        this.$message.success(res.Message)
                        this.dialogVisible = false
                        this.dialogVisible2 = false
                        this.ruleForm2.reason = ''
                        this.initData()
                    }else{
                        this.$message.error(res.Message)
                    }  
                }).catch( error =>{
                    console.log(error);
                })  
            }else {
                console.log('error submit!!');
                return false;
            } 
        }) 
    },            
    searchQuery() {
        this.getUserList()
    },
    resetForm(formName) {
        this.$refs[formName].resetFields();
    },
    handleClose(){
        this.resetForm('ruleForm')
        this.dialogVisible = false
    },
    handleClose2(){
        this.resetForm('ruleForm2')
        this.dialogVisible2 = false
        this.ruleForm2.reason = ''
    },
    handleClose3(){
        this.resetForm('ruleForm3')
        this.showScore = false
    },
    handleClose4(){
        this.resetForm('ruleForm4')
        this.showRole = false
    },
    changeTabs(){
        if(this.activeName === 'a'){
            this.initData()
        }else{
            this.getUserList()
        }
    },
    handleScore(row,flag){
        this.showScore = true
        this.scoreFlag = flag
        this.clientNo = row.userId
    },
    submitScore(formName){          
        this.$refs[formName].validate((valid) => {
            if (valid) {
                let params = {
                    opcode: this.$code.MemberScoreSet,
                    i_client_no: this.clientNo,
                    i_integral: this.ruleForm3.score,
                    i_flag: this.scoreFlag
                }
                this.$api.requestAPI(params).then(res =>{
                    if(res.IsSuccess){
                        this.showScore = false
                        this.$message.success(res.Message)
                        this.getUserList()
                    }else{
                        this.$message.error(res.Message)
                    }
                })
            }              
        })        
    },
    handleSetting(row){
       this.showRole = true
       this.userId = row.userId       
    },
    submitRole(){
        let params = {
            opcode: this.$code.UserAuth,
            i_client_no: this.userId,
            c_type: this.ruleForm4.role,
            i_starrating_new: this.ruleForm4.level
        }
        this.$api.requestAPI(params).then(res=>{
            if(res.IsSuccess){
                this.$message.success('设置成功')
                this.getUserList()
                this.showRole = false
            }else{
                this.$message.error(res.Message)
            }
        })
    },    
    handleSelectRole(value){
        let roleNo = 0
        if(value === '1'){
            roleNo = 120
        }else  if(value === '2'){
            roleNo = 102
        }else if(value === '3'){
            roleNo = 103  
        }else if(value === '4'){
            roleNo = 104
        }else if(value === '5'){
            roleNo = 105
        }
        setTimeout(()=>{
            this.getRoleAsLevel(roleNo)
        },10)
    },
    // 一键同步会员信息到 营销系统
    sendMemberInfo(){
        //加载中 
        this.loading = true
        this.callApisArrange(this.tableData2).then(()=>{
            this.loading = false
            console.log("调用完了")
            this.$message.success('会员信息同步完成')
        })
    },
     // 异步调用函数 
     async callApisArrange(arr) {  
            return arr.reduce(async (promiseChain, data) =>{
                await  promiseChain
                try {                      
                    const res = await this.submitArrange(data); 
                    // console.log(data)  
                } catch (error) {  
                    // console.error(`Error calling API at`, error);  
                }  
            }, Promise.resolve()) 
    },  
    // 循环调用接口
    submitArrange(row){
        return new Promise((resolve, reject) => {    
            let params = {
                opcode: this.$code.SendSystemMemberInfo,
                i_client_no: row.userId,
                RealName: row.shortname,
                Mobile: row.phone,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {                        
                    resolve(res)                 
                }
            }).catch(err=>reject(err)) 
        })         
    },
    handleChangeArea(value){
        this.cityList = []
        this.ruleForm.province = value
        this.ruleForm.city = ''
        let cityObj = this.areaList.filter(i=> i.label === value)
        this.cityList = cityObj[0].cities
    },
    handleChangecity(value){
        this.ruleForm.city = value
    },
    getExportQuery(){
        let params ={
            opcode: this.$code.MemberRank,
            i_client_no: '',
            v_name: '',
            v_phone: '',
            v_provice: '',
            v_city: '',
            c_type: '',
            pagesize: '',
            page:  '',
        }
        this.$api.requestAPI(params).then(res =>{
            if(res.IsSuccess){
                let result = res.Data.DataTable
                if(result.length > 0 ){   
                    let arr = result.map(item=>{                    
                    return{
                        '选手账号': item['选手账号'],
                        '全称':  item['全称'],
                        '姓名':  item['姓名'],
                        '手机号': item['手机号'],
                        '角色': item['角色'],
                        '地区': item['省'] + item['市'],
                        '等级': item['角色'] === '选手'? Number(item['等级']):item['等级'],
                        '积分': item['积分'],
                        '单位': item['公司'],   
                    }
                    })   
                    this.exportData = arr          
                }               
            }else{
                this.exportData= []
                this.$message.error('暂无数据')
            }
        })
    },
    handleExport(){
        this.getExportQuery()        
        setTimeout(()=>{
            if(this.exportData.length >0){
                this.$help.ExportFormData(this.exportData,'会员信息表')
            }else{
                this.$message.error('暂无数据')
            }           
        },500)
    },
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.detail-wrap{
    width:90%
}
</style>


// WEBPACK FOOTER //
// src/views/admin/adminAudit.vue